import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { loadUser } from "../Dashboard/actions/auth";
import { Redirect } from "react-router-dom";
import { URL_WRAPPER } from "../Dashboard/actions/types";

export const RedirectToWrapper = (props) => {
  const [showSpinner, setShowSpinner] = useState(true);

  // check for the token in the url
  var check_token = window.location.href.split("auth=")[1];
  if (check_token !== undefined) {
    localStorage.setItem("res_token", check_token);
  }

  useEffect(() => {
    setTimeout(() => {
      setShowSpinner(false);
    }, 1500);
  }, []);

  if (props.auth.isAuthenticated) {
    return <Redirect to="/dashboard/maps/fixed_zero"></Redirect>;
  }

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 22,
      }}
    >
      {/* show spinner for 1.5 seconds */}
      {showSpinner ? (
        <div>
          <i
            className="fa fa-spinner fa-spin"
            style={{ fontSize: 40, marginLeft: 25 }}
          ></i>
          <div>Loading...</div>
        </div>
      ) : (
        <span>
          To access the application, please refer to the main&nbsp;
          <a href={URL_WRAPPER}>page</a>.
        </span>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { loadUser })(RedirectToWrapper);
